import { useAuth } from "@/context/AuthContext";
import PageHeader from "@/components/PageHeader";
import { Card } from "@/components/ui/card";
import { FeedbackForm } from "@/components/FeedbackForm";
import { LifeBuoy } from "lucide-react";

export default function Feedback() {
  const { user } = useAuth();
  return (
    <div>
      <PageHeader
        title="Hjälp & feedback"
        description="Har du en fråga, en idé eller hittat något som inte fungerar? Skriv till oss – vi läser allt och vill gärna göra HAMN bättre tillsammans med dig."
      />
      <Card className="rounded-2xl border-border p-6 max-w-2xl">
        <div className="flex items-center gap-2 mb-4 text-primary">
          <LifeBuoy className="h-5 w-5" />
          <span className="text-sm text-muted-foreground">
            Skickas som <span className="font-medium text-foreground">{user?.name}</span>
            {user?.email ? ` (${user.email})` : ""}
          </span>
        </div>
        <FeedbackForm showContactFields={false} />
      </Card>
    </div>
  );
}
